/* =========================================================
   MICRAL TCG — JavaScript del tema
   Todo funciona también sin JS (formularios nativos de Shopify);
   este archivo solo mejora la experiencia.
   ========================================================= */
(function () {
  'use strict';

  document.documentElement.classList.add('js');

  var T = window.MicralTheme || { routes: {}, strings: {} };
  var S = T.strings || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Helpers ---------- */
  function money(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || T.currency || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  var toastTimer;
  function toast(message, isError) {
    var el = $('#MicralToast');
    if (!el) return;
    el.innerHTML = '';
    var span = document.createElement('span');
    span.textContent = message;
    el.appendChild(span);
    if (!isError) {
      var a = document.createElement('a');
      a.href = T.routes.cart;
      a.textContent = S.view_cart;
      el.appendChild(a);
    }
    el.classList.toggle('is-error', !!isError);
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.hidden = true; }, 300);
    }, 4000);
  }

  function refreshCartCount() {
    return fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  /* ---------- Header: altura para el menú móvil ---------- */
  function setHeaderBottom() {
    var header = $('[data-header]');
    if (!header) return;
    var bottom = Math.max(0, header.getBoundingClientRect().bottom);
    document.documentElement.style.setProperty('--m-header-bottom', bottom + 'px');
  }
  setHeaderBottom();
  window.addEventListener('resize', setHeaderBottom);
  window.addEventListener('scroll', setHeaderBottom, { passive: true });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.m-drawer[open]').forEach(function (d) { d.removeAttribute('open'); });
  });
  $$('.m-drawer').forEach(function (d) {
    d.addEventListener('toggle', function () {
      setHeaderBottom();
      document.body.style.overflow = d.open ? 'hidden' : '';
    });
  });

  /* ---------- Añadir al carrito (AJAX) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-ajax-cart-form]')) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }

    fetch(T.routes.cart_add + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || S.error);
          return data;
        });
      })
      .then(function () {
        toast(S.added);
        refreshCartCount();
      })
      .catch(function (err) {
        toast((err && err.message) || S.error, true);
      })
      .then(function () {
        if (!btn) return;
        btn.classList.remove('is-loading');
        btn.disabled = btn.getAttribute('data-available') === 'false';
      });
  });

  /* ---------- Selector de cantidad (+ / −) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-btn]');
    if (!b) return;
    e.preventDefault();
    var input = b.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    var max = input.max ? parseInt(input.max, 10) : Infinity;
    var value = (parseInt(input.value, 10) || 0) + (b.getAttribute('data-qty-btn') === 'plus' ? 1 : -1);
    input.value = Math.min(max, Math.max(min, value));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Carrito: actualizar al cambiar cantidades ---------- */
  document.addEventListener('change', function (e) {
    var form = e.target.closest && e.target.closest('[data-cart-form]');
    if (!form || !e.target.matches('input[type="number"]')) return;
    clearTimeout(form._timer);
    form._timer = setTimeout(function () { form.submit(); }, 600);
  });

  /* ---------- Página de producto: galería y variantes ---------- */
  function setActiveMedia(root, id) {
    if (!root || !id) return;
    var found = $('[data-media-id="' + id + '"]', root);
    if (!found) return;
    $$('[data-media-id]', root).forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-media-id') === String(id));
    });
    $$('[data-thumb]', root).forEach(function (el) {
      el.setAttribute('aria-current', el.getAttribute('data-thumb') === String(id) ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-thumb]');
    if (!t) return;
    setActiveMedia(t.closest('[data-product]'), t.getAttribute('data-thumb'));
  });

  $$('[data-product]').forEach(function (root) {
    var jsonEl = $('[data-product-json]', root);
    if (!jsonEl) return;
    var product, stock = {};
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var stockEl = $('[data-variant-stock]', root);
    if (stockEl) { try { stock = JSON.parse(stockEl.textContent); } catch (e) {} }

    var idInput = $('[data-product-form] [name="id"]', root);
    var btn = $('[data-add-button]', root);
    var btnText = btn && $('[data-add-text]', btn);
    var priceEl = $('[data-price]', root);
    var compareEl = $('[data-compare-price]', root);
    var stockLabel = $('[data-stock-label]', root);
    var fieldsets = $$('fieldset[data-option-index]', root);

    function update() {
      var selected = fieldsets.map(function (fs) {
        var c = $('input:checked', fs);
        return c ? c.value : null;
      });
      fieldsets.forEach(function (fs, i) {
        var label = $('[data-selected-value]', fs);
        if (label) label.textContent = selected[i] || '';
      });

      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      });

      if (!variant) {
        if (btn) { btn.disabled = true; btn.setAttribute('data-available', 'false'); }
        if (btnText) btnText.textContent = S.unavailable;
        if (stockLabel) stockLabel.hidden = true;
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (priceEl) {
        priceEl.textContent = money(variant.price);
        priceEl.classList.toggle('m-price__current--sale', variant.compare_at_price > variant.price);
      }
      if (compareEl) {
        if (variant.compare_at_price > variant.price) {
          compareEl.textContent = money(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (btn) {
        btn.disabled = !variant.available;
        btn.setAttribute('data-available', variant.available ? 'true' : 'false');
      }
      if (btnText) btnText.textContent = variant.available ? S.add_to_cart : S.sold_out;

      if (stockLabel) {
        var info = stock[variant.id] || {};
        var state = !variant.available ? 'out' : (info.low ? 'low' : 'in');
        stockLabel.className = 'm-stock m-stock--' + state;
        stockLabel.textContent = state === 'out' ? S.sold_out : (state === 'low' ? S.low_stock : S.in_stock);
        stockLabel.hidden = false;
      }

      if (variant.featured_media) setActiveMedia(root, variant.featured_media.id);

      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState(null, '', url.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('fieldset[data-option-index]')) update();
    });
  });

  /* ---------- Filtros y orden del catálogo ---------- */
  var facets = $('[data-facets-form]');
  if (facets) {
    var goFilters = function () {
      var params = new URLSearchParams();
      new FormData(facets).forEach(function (value, key) {
        if (value !== '') params.append(key, value);
      });
      window.location.search = params.toString();
    };
    facets.addEventListener('change', goFilters);
    facets.addEventListener('submit', function (e) { e.preventDefault(); goFilters(); });
    if (facets.id) {
      $$('[form="' + facets.id + '"]').forEach(function (el) {
        el.addEventListener('change', goFilters);
      });
    }
  }

  var facetsWrap = $('[data-facets-wrap]');
  if (facetsWrap && window.matchMedia('(min-width: 990px)').matches) {
    facetsWrap.setAttribute('open', '');
  }

  /* ---------- Productos recomendados ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var inner = tmp.querySelector('[data-recommendations]');
        if (inner && inner.innerHTML.trim()) {
          el.innerHTML = inner.innerHTML;
          el.hidden = false;
        }
      })
      .catch(function () {});
  });

  /* ---------- Tarjeta regalo: copiar código ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-copy]');
    if (!b || !navigator.clipboard) return;
    navigator.clipboard.writeText(b.getAttribute('data-copy'));
  });
})();
